import styled from "styled-components";

import { DESKTOP_BREAKPOINT } from "../AppShell/styles";

type Props = {
  borderBottom?: boolean;
};

export const Box = styled.div<Props>`
  padding: 2rem 0rem;
  margin: 0rem 2rem;
  border-bottom: ${props => props.borderBottom && "1px solid var(--color-neutral-dark)"};

  @media not all and (min-width: ${DESKTOP_BREAKPOINT}) {
    padding: 20px 0;
    margin: 0 20px;
  }

  &.npt {
    padding-top: 0;
  }
  &.npb {
    padding-bottom: 0;
  }
`;
